import { Theme } from './types/styled'
import deepmerge from 'deepmerge'

type DeepPartial<T> = T extends object ? { [K in keyof T]?: DeepPartial<T[K]> } : T

const colorPrimary = '#187D41'
const colorSecondary = '#929CA8'
const colorSwiss = '#D92626'
const colorInfo = '#519BC6'
const colorError = '#B76161'
const colorMagenta = '#F11873'
const colorMint = '#D7FF97'

const baseSchema = {
  breakpoints: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
  },
  zIndex: {
    modal: 4,
  },
  fontSize: {
    chat: '14px',
  },
  padding: {
    chatMessage: '12px 12px 12px 12px',
  },
  borderRadius: {
    chatMessage: {
      small: '5px',
      regular: '17px',
    },
  },
  color: {
    primary: colorPrimary,
    secondary: colorSecondary,
    info: colorInfo,
    error: colorError,
    magenta: colorMagenta,
    mint: colorMint,
    swiss: colorSwiss,
    white: '#FFFFFF',
    disabled: 'grey',
    main: {
      messageTime: '#919BA8',
      messageMyTextWrapper: 'rgba(255,255,255,1)',
      messageMy: '#2EAA77',
      messageText: '#FFF',
      messagePartnerText: '#F7F9FA',
      fileMessage: {
        icon: '#283582',
        background: '#3F51B5',
      },
      linkMessage: {
        text: '#0B3D65',
        bg: 'rgba(255,255,255,.7)',
        hoverBg: 'rgba(255,255,255,1)',
      },
      inputText: '#FFF',
      inputPlaceholder: '#FFF',
    },
    button: {
      bg: {
        primary: colorPrimary,
        secondary: colorSecondary,
        swiss: colorSwiss,
        info: colorInfo,
        error: colorError,
      },
      bgHover: {
        primary: '#299D58',
        secondary: '#52525E',
        swiss: '#EA3838',
      },
    },
    icon: {
      primary: colorPrimary,
      secondary: '#FFF',
      swiss: colorSwiss,
      info: colorInfo,
      error: colorError,
      magenta: colorMagenta,
      mint: colorMint,
      white: '#FFF',
    },
    avatar: {
      text: '#FFF5D2',
      bg: '#595973'
    },
  },
} as Theme

export const lightTheme = deepmerge(baseSchema, {
  color: {
    primary: '#FFF',
    secondary: '#E1E1E1',
    header: {
      title: '#14171E',
    },
    main: {
      background: '#E8F3FB',
      messagePartnerText: '#14171E',
      messageMyTextWrapper: '#FFF',
      messagePartner: '#FFF',
      messageBotButtonText: 'red',
      linkMessagePartner: {
        text: '#0B3D65',
        bg: 'rgba(255,255,255,1)',
      },
      inputText: '#000',
      inputPlaceholder: 'grey',
    },
    button: {
      bgHover: {
        secondary: 'lightgrey',
      },
    },
    icon: {
      secondary: colorSecondary,
      mint: 'green',
    },
  }
} satisfies DeepPartial<Theme>) satisfies Theme

export const darkTheme = deepmerge(baseSchema, {
  color: {
    primary: '#222730',
    secondary: '#292F3A',
    header: {
      title: '#FFF',
    },
    main: {
      background: '#14171E',
      messagePartner: '#222730',
      messageBotButtonText: '#FF9800',
      linkMessagePartner: {
        text: '#03A9F4',
        bg: 'rgba(0,0,0,.8)',
      },
    },
  },
} satisfies DeepPartial<Theme>) satisfies Theme
export const blueTheme = deepmerge(baseSchema, {
  color: {
    primary: '#1D2852',
    secondary: '#222E5E',
    header: {
      title: '#FFF',
    },
    main: {
      background: '#060E37',
      messagePartner: '#1D2852',
      messageBotButtonText: '#FF9800',
      linkMessagePartner: {
        text: '#0B3D65',
        bg: 'rgba(255,255,255,1)',
      },
    },
  }
} satisfies DeepPartial<Theme>) satisfies Theme

export const getTheme = () => {
  switch (window.DCC_SHARED.colors) {
    case 'blue': return blueTheme
    case 'dark': return darkTheme
    case 'light':
    default:
      return lightTheme

  }
}